import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAuth } from "@/lib/auth";
import { Layout } from "@/components/Layout";
import { SiteLayout } from "@/components/site/SiteLayout";
import Prospects from "@/pages/Prospects";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Calendar from "@/pages/Calendar";
import Quotes from "@/pages/Quotes";
import Invoices from "@/pages/Invoices";
import Employees from "@/pages/Employees";
import Home from "@/pages/site/Home";
import Services from "@/pages/site/Services";
import Book from "@/pages/site/Book";
import Confirmed from "@/pages/site/Confirmed";
import Account from "@/pages/site/Account";
import BookingAdmin from "@/pages/site/BookingAdmin";
import FastAgreement from "@/pages/site/FastAgreement";
import ProspectFinderPage from "@/pages/site/ProspectFinderPage";
import { About, Faq, Health, Privacy, Terms, Areas, Contact, Landing } from "@/pages/site/Info";
import landing from "@/data/landing.json";

const ADMIN = ["owner", "admin"];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/tjenester" element={<Services />} />
              <Route path="/priser" element={<Services />} />
              <Route path="/fast-renholdsavtale" element={<FastAgreement />} />
              <Route path="/om-oss" element={<About />} />
              <Route path="/sporsmal-og-svar" element={<Faq />} />
              <Route path="/renhold-og-helse" element={<Health />} />
              <Route path="/personvern" element={<Privacy />} />
              <Route path="/vilkar" element={<Terms />} />
              <Route path="/omrader" element={<Areas />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/prospect-finder" element={<ProspectFinderPage />} />
              {landing.map((l) => <Route key={l.slug} path={`/${l.slug}`} element={<Landing />} />)}
              <Route path="/tjenester/:slug" element={<Services />} />
              <Route path="/bestill" element={<Book />} />
              <Route path="/bestilling/bekreftet" element={<Confirmed />} />
              <Route path="/min-side" element={<Account />} />
            </Route>
            <Route path="/admin" element={<RequireAuth roles={ADMIN}><BookingAdmin /></RequireAuth>} />
            <Route path="/login" element={<Login />} />
            <Route path="/pro" element={<RequireAuth><Layout /></RequireAuth>}>
              <Route index element={<Dashboard />} />
              <Route path="kunder" element={<Customers />} />
              <Route path="kalender" element={<Calendar />} />
              <Route path="tilbud" element={<RequireAuth roles={ADMIN}><Quotes /></RequireAuth>} />
              <Route path="fakturaer" element={<RequireAuth roles={ADMIN}><Invoices /></RequireAuth>} />
              <Route path="ansatte" element={<RequireAuth roles={ADMIN}><Employees /></RequireAuth>} />
              <Route path="prospekter" element={<RequireAuth roles={ADMIN}><Prospects /></RequireAuth>} />
              <Route path="innstillinger" element={<RequireAuth roles={ADMIN}><Settings /></RequireAuth>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
